/* eslint-disable */
/**
 * Rewrites known DEV TDX/Universal Player hosts to staging while running local testbed flows.
 * This avoids 500s when a DEV endpoint is unavailable for local-stg style testing.
 */
const DEV_TDX_HOST = 'tdx-dev.acs.pearson.com';
const DEV_UNIVERSAL_PLAYER_HOST = 'service.universalplayer-dev.pearsondev.tech';

const getLocalRewriteTargets = () => ({
  [DEV_TDX_HOST]: (process.env.REACT_APP_TDX_ACS_ORIGIN || 'https://tdx-stg.acs.pearson.com').trim(),
  [DEV_UNIVERSAL_PLAYER_HOST]: (
    process.env.REACT_APP_UNIVERSALPLAYER_STG_ORIGIN || 'https://service.universalplayer-stg.pearsondev.tech'
  ).trim()
});

const shouldEnableRewrite = () => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === 'local.evergreen.pearson.com' || host.includes('local-dev.pearson');
};

export function rewriteTdxDevUrls(urlString) {
  if (!urlString || typeof urlString !== 'string' || !shouldEnableRewrite()) return urlString;

  try {
    const url = new URL(urlString);
    const targetBase = getLocalRewriteTargets()[url.hostname];
    if (!targetBase) return urlString;

    const target = new URL(targetBase);
    return new URL(url.pathname + url.search + url.hash, target.origin).href;
  } catch (err) {
    return urlString;
  }
}

export function ensureTdxAcsDevToStagingRewrite() {
  if (typeof window === 'undefined' || !shouldEnableRewrite()) return;

  const win = window;
  if (win.__AIADMIN_TDX_HOST_REWRITE_APPLIED__) return;
  win.__AIADMIN_TDX_HOST_REWRITE_APPLIED__ = true;

  const rewriteRequestInput = (input) => {
    if (typeof input === 'string') return rewriteTdxDevUrls(input);
    if (input instanceof URL) {
      const rewritten = rewriteTdxDevUrls(input.href);
      return rewritten !== input.href ? new URL(rewritten) : input;
    }
    if (typeof Request !== 'undefined' && input instanceof Request) {
      const rewritten = rewriteTdxDevUrls(input.url);
      return rewritten !== input.url ? new Request(rewritten, input) : input;
    }
    return input;
  };

  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init) => nativeFetch(rewriteRequestInput(input), init);

  const nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function open(method, url, async, username, password) {
    const urlStr = typeof url === 'string' ? url : url instanceof URL ? url.href : String(url);
    const rewritten = rewriteTdxDevUrls(urlStr);
    return nativeOpen.call(this, method, rewritten, async ?? true, username ?? null, password ?? null);
  };
}
